import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { LOCAL_BUSINESS } from "@/lib/structured-data";

export const Route = createFileRoute("/about")({
  head: () => {
    const base = seo({
      title: "About",
      description:
        "Gary Risler of SeaClay Roofing explains insulation options in plain language. 25+ years of spray foam expertise in Prairie Farm, WI.",
      path: "/about",
    });
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              LOCAL_BUSINESS,
              {
                "@type": "AboutPage",
                name: "About SeaClay Roofing & Spray Foam Insulation",
                url: "https://seaclaysprayfoam.com/about",
                mainEntity: {
                  "@type": "Person",
                  name: "Gary Risler",
                  jobTitle: "Founder",
                  worksFor: { "@id": `${LOCAL_BUSINESS["@id"]}` },
                },
              },
            ],
          }),
        },
      ],
    };
  },
});
